import { isAmpPageEndsWith } from '~/utils/router';

export default defineNuxtPlugin((nuxtApp) => {
  const { path } = useRoute();
  const isAmp = isAmpPageEndsWith(path);

  nuxtApp.provide('isAMP', isAmp);
  nuxtApp.vueApp.provide('isAMP', isAmp);
});
